module.exports = __webpack_public_path__ + "static/media/working.cf9c8071.JPG";